import useUpdateDocumentStatus from "@/common/api/mutation/documentsMutations/useUpdateDocumentStatus.mutation";
import { usePermissions } from "@/common/contexts/Permissions.context";
import { cn, queryClient } from "@/common/utils";
import { Select } from "antd";
import { toast } from "react-toastify";

const pickStatusFilterColor = (value: string) => {
  switch (value) {
    case "active":
      return "bg-[#F3F9FC] text-[#0E72FF]";
    case "inactive":
      return "bg-[#F5F5F5] text-[#A7A7A7]";
    case "updated":
      return "bg-[#D8F2D4] text-[#0F7B1A]";
    case "expired":
      return "bg-[#FFEAEA] text-[#DE3721]";
    case "terminated":
      return "bg-[#F5F5F5] text-[#A7A7A7]";
    default:
      break;
  }
};

export default function DocumentStatusSelect({
  id,
  value,
  options,
}: {
  id: string;
  value: string;
  options: { label: string; value: string }[];
}) {
  const { mutate } = useUpdateDocumentStatus();
  const { isHavePermission } = usePermissions();

  const handleUpdate = (newValue: string) => {
    if (newValue !== value) {
      mutate(
        {
          id,
          value: newValue,
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries();
            toast.success("Document updated successfully!");
          },
        }
      );
    }
  };

  return (
    <>
      <Select
        className={cn(
          "font-kanit font-light rounded-full text-[14px] px-[14px] border-none",
          pickStatusFilterColor(value)
        )}
        defaultValue={value}
        options={options}
        onSelect={(newValue) => handleUpdate(newValue)}
        popupMatchSelectWidth={false}
        disabled={!isHavePermission("documents_update")}
      />
    </>
  );
}
